import { Hidden } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    trailingPeriodContainer: {
        width: "100%",
        height: "100%",
        position: "absolute",
        background: "grey",
        alignItems: "center",
        justifyContent: "center",
        top: 0,
        left: 0,
    },

    trailingPeriodInfoBox: {
        position: "absolute",
        background: "grey",
        width: "45%",
        height: "45%",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        left: "0",
        right: "0",
        top: "15%",
        textAlign: "center",
    },

    trailingPeriodInfoText: {
        fontSize: "1vw",
        marginTop: "10%",
    },

    trailingPeriodCountdown: {
        fontSize: "3vw",
    },

    countdownContainer: {
        background: "#d8d8d8",
        position: "absolute",
        margin: "15px 0",
        height: "30px",
        width: "300px",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        left: "0",
        right: "0",
    },

    countdownBar: {
        background: "linear-gradient(to left, #F2709C, #FF9472)",
        color: "#fff",
        boxShadow: "0 3px 3px -5px #F2709C, 0 2px 5px #F2709C",
        borderRadius: "20px",
        dispaly: "flex",
        height: "100%",
        width: (props) => `${props.dimensions}%`,
    },
}));

export { useStyles };
